export default class NotificationManager {
    constructor () {
        const notifications = document.querySelector('#site-notifications');

        if (!notifications) {
            throw new Error('Notifications container not found');
        }

        this.container = notifications;

        this.icons = {
            success: `
                <div class="site-notification--icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1209 7.84638 17.2635 5.78216 15.7407 4.25932C14.2178 2.73648 12.1536 1.87913 10 1.875ZM13.8672 8.57812L9.28907 12.9531C9.17071 13.0645 9.01406 13.126 8.85157 13.125C8.77214 13.1261 8.69328 13.1115 8.61953 13.082C8.54578 13.0525 8.47861 13.0087 8.42188 12.9531L6.13282 10.7656C6.06933 10.7102 6.01769 10.6426 5.98102 10.5667C5.94434 10.4909 5.92338 10.4084 5.9194 10.3242C5.91542 10.24 5.92849 10.1559 5.95784 10.077C5.98719 9.99798 6.03221 9.92575 6.09019 9.86461C6.14816 9.80347 6.2179 9.75469 6.29522 9.72119C6.37253 9.68769 6.45582 9.67017 6.54007 9.66968C6.62433 9.66919 6.70781 9.68574 6.78551 9.71834C6.86321 9.75094 6.93351 9.79891 6.99219 9.85938L8.85157 11.6328L13.0078 7.67188C13.1293 7.56585 13.2871 7.51091 13.4482 7.51853C13.6093 7.52615 13.7612 7.59575 13.8722 7.71277C13.9832 7.8298 14.0446 7.98519 14.0437 8.14646C14.0428 8.30773 13.9795 8.4624 13.8672 8.57812Z" fill="#68CC9A" />
                    </svg>
                </div>
            `,
            error: `
                <div class="site-notification--icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.4921 14.6875L11.6249 2.81245C11.4605 2.52685 11.2237 2.28962 10.9384 2.12467C10.6532 1.95972 10.3294 1.87286 9.99991 1.87286C9.67037 1.87286 9.34665 1.95972 9.06136 2.12467C8.77608 2.28962 8.53931 2.52685 8.37491 2.81245L1.50772 14.6875C1.3409 14.9716 1.25224 15.2948 1.25075 15.6243C1.24926 15.9538 1.335 16.2779 1.49924 16.5635C1.66349 16.8492 1.9004 17.0863 2.18593 17.2507C2.47145 17.4152 2.79541 17.5012 3.12491 17.5H16.8749C17.2044 17.5012 17.5284 17.4152 17.8139 17.2507C18.0994 17.0863 18.3363 16.8492 18.5006 16.5635C18.6648 16.2779 18.7505 15.9538 18.7491 15.6243C18.7476 15.2948 18.6589 14.9716 18.4921 14.6875ZM9.37491 8.12495C9.37491 7.95919 9.44075 7.80022 9.55796 7.68301C9.67517 7.5658 9.83415 7.49995 9.99991 7.49995C10.1657 7.49995 10.3246 7.5658 10.4418 7.68301C10.5591 7.80022 10.6249 7.95919 10.6249 8.12495V11.2499C10.6249 11.4157 10.5591 11.5747 10.4418 11.6919C10.3246 11.8091 10.1657 11.875 9.99991 11.875C9.83415 11.875 9.67517 11.8091 9.55796 11.6919C9.44075 11.5747 9.37491 11.4157 9.37491 11.2499V8.12495ZM9.99991 15C9.81449 15 9.63323 14.945 9.47906 14.842C9.32489 14.7389 9.20473 14.5925 9.13377 14.4212C9.06281 14.2499 9.04425 14.0614 9.08042 13.8796C9.11659 13.6977 9.20588 13.5306 9.33699 13.3995C9.4681 13.2684 9.63515 13.1791 9.81701 13.143C9.99887 13.1068 10.1874 13.1254 10.3587 13.1963C10.53 13.2673 10.6764 13.3874 10.7794 13.5416C10.8824 13.6958 10.9374 13.877 10.9374 14.0625C10.9374 14.3111 10.8386 14.5495 10.6628 14.7254C10.487 14.9012 10.2485 15 9.99991 15Z" fill="#FF4930"/>
                    </svg>
                </div>
            `
        };

        this.content = (title, message) => `
            <div class="site-notification--content">
                <h5 class="h5 site-title site-notification--title">${title}</h5>
                <p class="site-notification--text">${message}</p>
            </div>
        `;

        this.close = `
            <div tabindex="0" class="site-notification--close">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.6281 2.75314L2.75314 10.6281C2.67109 10.7102 2.625 10.8215 2.625 10.9375C2.625 11.0535 2.67109 11.1648 2.75314 11.2469C2.83519 11.3289 2.94647 11.375 3.0625 11.375C3.17853 11.375 3.28981 11.3289 3.37186 11.2469L11.2469 3.37186C11.3289 3.28981 11.375 3.17853 11.375 3.0625C11.375 2.94647 11.3289 2.83519 11.2469 2.75314C11.1648 2.67109 11.0535 2.625 10.9375 2.625C10.8215 2.625 10.7102 2.67109 10.6281 2.75314Z" fill="#5C5C5C"/>
                    <path d="M3.37186 2.75314C3.28981 2.67109 3.17853 2.625 3.0625 2.625C2.94647 2.625 2.83519 2.67109 2.75314 2.75314C2.67109 2.83519 2.625 2.94647 2.625 3.0625C2.625 3.17853 2.67109 3.28981 2.75314 3.37186L10.6281 11.2469C10.7102 11.3289 10.8215 11.375 10.9375 11.375C11.0535 11.375 11.1648 11.3289 11.2469 11.2469C11.3289 11.1648 11.375 11.0535 11.375 10.9375C11.375 10.8215 11.3289 10.7102 11.2469 10.6281L3.37186 2.75314Z" fill="#5C5C5C"/>
                </svg>
            </div>
        `;
    }

    createNotification (type, title, message) {
        const el = document.createElement('div');

        el.classList.add('site-notification');

        if (type === 'success') {
            el.innerHTML = `
                <div class="site-notification__inner">
                    ${this.icons.success}
                    ${this.content(title, message)}
                    ${this.close}
                </div>
            `;
        } else {
            el.innerHTML = `
                <div class="site-notification__inner">
                    ${this.icons.error}
                    ${this.content(title, message)}
                    ${this.close}
                </div>
            `;
        }

        return el;
    }

    sendNotification (type, title, message) {
        if (!this.container.children.length) {
            this.container.classList.remove('hidden');
        }

        const el = this.createNotification(type, title, message);

        this.container.append(el);

        this.setHideHandler(el);
        this.setCloseHandler(el);
    }

    setHideHandler (el) {
        if (!el) return;

        setTimeout(() => { if (el) el.classList.add('hidden') }, 5000);
        setTimeout(() => {
            if (el) el.remove();

            if (!this.container.children.length) {
                this.container.classList.add('hidden');
            }
        }, 5800);
    }

    setCloseHandler (el) {
        if (!el) return;

        const close = el.querySelector('.site-notification--close');

        close.addEventListener('click', () => {
            if (el) el.classList.add('hidden');

            setTimeout(() => {
                if (el) el.remove();

                if (!this.container.children.length) {
                    this.container.classList.add('hidden');
                }
            }, 800);
        });
    }
}
